<script lang="ts">
    export let width = "1.25rem";
    export let height = "1.25rem";
</script>

<svg
    {width}
    {height}
    class="strokeCurrentColor"
    viewBox="0 0 24 24"
    stroke-width="2"
    aria-hidden="true"
    ><path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21 8c0-2-2-4-5-4l-4 2-4-2C5 4 3 6 3 8c0 7 9 12 9 12s9-5 9-12z"
    /></svg
>
